/** @format */

import { debounce } from '@power/utils';
import { $utils } from '@/utils/publicUtils';
/**
 * 显示字段
 */
export default {
	props: {
		displayField: {
			type: Boolean,
			default: false,
		},
		displayFieldData: {
			type: Array,
			default: () => [],
		},
		// 是否在表尾显示合计行
		showSummary: {
			type: Boolean,
			default: false,
		},
		// 合计行第一列的文本
		sumText: {
			type: String,
		},
	},
	data() {
		return {
			displayFieldVisible: false,
			displayFields: [],
		};
	},
	watch: {
		displayFieldData: {
			handler() {
				if (this.displayField) {
					if ($utils.isNotEmpty(this.displayFieldData)) {
						this.displayFields = JSON.parse(JSON.stringify(this.displayFieldData));
					} else {
						const displayFields = [];
						this.columns.filter((column) => {
							if (!column.hidden) {
								displayFields.push(column);
							}
						});
						this.displayFields = JSON.parse(JSON.stringify(displayFields));
					}
				}
			},
			deep: true,
			immediate: true,
		},
		displayFields() {
			debounce(this.handleTableHeight, 100)();
		},
	},
	beforeUnmount() {
		this.displayFields = null;
	},
	methods: {
		handleDisplayField(data) {
			this.$emit('display-field-change', data, (r) => {
				if (r) {
					this.displayFieldVisible = false;
					this.displayFields = $utils.isNotEmpty(data) ? JSON.parse(JSON.stringify(data)) : this.columns;
				}
			});
		},
		/**
		 * 默认的表单统计 只有数字和计数器可以进行计算
		 */
		defaultSummaryMethod(param) {
			const { columns, data } = param;
			if (columns) {
				const numberColumnMap = {};
				this.columns.forEach((column) => {
					if (column.dataType === 'number' || column.field_type === 'number' || column.field_type === 'inputNumber') {
						numberColumnMap[column.prop] = column;
					}
				});

				const sums = [];
				columns.forEach((column, index) => {
					if (index === 0) {
						sums[index] = this.sumText;
						return;
					}
					const property = column.property;
					if (!numberColumnMap[property]) {
						sums[index] = '';
						return;
					}

					const values = data.map((item) => Number(item[property]));
					const precisions = [];
					let notNumber = true;
					values.forEach((value) => {
						if (!isNaN(value)) {
							notNumber = false;
							const decimal = `${value}`.split('.')[1];
							precisions.push(decimal ? decimal.length : 0);
						}
					});
					if (!notNumber) {
						sums[index] = values.reduce((prev, curr) => {
							const value = Number(curr);
							if (!isNaN(value)) {
								return prev + curr;
							} else {
								return prev;
							}
						}, 0);
						// 千分位
						// sums[index] =  this.$utils.comdify(sums[index])
						// 保留两位小数
						sums[index] = sums[index].toFixed(2);
					} else {
						sums[index] = '';
					}
				});
				return sums;
			}
		},
	},
};
